import { TFunction } from 'i18next'
import { RRule } from 'rrule'

import { COLOR_PALETTE } from '../context/Data'

/**
 * Generate a deterministic color from a string (used for playlist color assignment)
 */
export const getColorFromString = (str: string): string => {
	let hash = 0
	for (let i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash)
		hash = hash & hash
	}
	const index = Math.abs(hash) % COLOR_PALETTE.length
	return COLOR_PALETTE[index]
}

/**
 * Converts Date to ISO string without timezone (no 'Z' suffix)
 * Ensures FullCalendar treats dates as timezone-agnostic local time
 * Prevents DST-related time shifts in recurring events
 */
export const toLocalISOString = (date: Date): string => {
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')
	const seconds = String(date.getSeconds()).padStart(2, '0')

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

/**
 * Days of week with RRule mapping for recurrence configuration with the translation
 */
export const getDaysOfWeek = (t: TFunction) => {
	return [
		{
			value: 'everyday',
			label: t('entities.schedule.repeat.everyday'),
			rruleDay: null,
		},
		{
			value: 'monday',
			label: t('entities.schedule.repeat.monday'),
			rruleDay: (RRule as any).MO,
		},
		{
			value: 'tuesday',
			label: t('entities.schedule.repeat.tuesday'),
			rruleDay: (RRule as any).TU,
		},
		{
			value: 'wednesday',
			label: t('entities.schedule.repeat.wednesday'),
			rruleDay: (RRule as any).WE,
		},
		{
			value: 'thursday',
			label: t('entities.schedule.repeat.thursday'),
			rruleDay: (RRule as any).TH,
		},
		{
			value: 'friday',
			label: t('entities.schedule.repeat.friday'),
			rruleDay: (RRule as any).FR,
		},
		{
			value: 'saturday',
			label: t('entities.schedule.repeat.saturday'),
			rruleDay: (RRule as any).SA,
		},
		{
			value: 'sunday',
			label: t('entities.schedule.repeat.sunday'),
			rruleDay: (RRule as any).SU,
		},
	]
}
